<template>
  <div class="leaderboard-page">
    <div class="page-title-box leaderboard-page__intro">
      <div class="leaderboard-page__heading">
        <span class="leaderboard-page__icon" aria-hidden="true">
          <svg viewBox="0 0 24 24">
            <rect x="4" y="5.5" width="16" height="14" rx="2" />
            <path d="M8 3v5M16 3v5M4 10h16M8 14h3M13 14h3M8 17h3" />
          </svg>
        </span>
        <div>
          <div class="page-title bold">Weekly In Crowd</div>
          <div class="page-info">This week's standout sisters across Sorority Wars.</div>
        </div>
      </div>
      <span class="leaderboard-page__period" :title="week || 'Weekly standings'">
        {{ week || 'Weekly standings' }}
      </span>
    </div>

    <div v-if="loadError" class="leaderboard-page__error" role="alert">
      <strong>Weekly standings could not be loaded.</strong>
      <span>Please refresh and try again.</span>
    </div>

    <div v-else class="leaderboard-page__grid">
      <InCrowdDisplay title="Successful Events" sub-title="Events" :data="events" :loading="loading" />
      <InCrowdDisplay title="Most Energy" sub-title="Energy" :data="energy" :loading="loading" />
      <InCrowdDisplay title="Most Gratitudes" sub-title="Gratitudes" :data="bounties" :loading="loading" />
      <InCrowdDisplay title="Most Fights Won" sub-title="Wins" :data="wins" :loading="loading" />
      <InCrowdDisplay title="Most Fights Lost" sub-title="Losses" :data="losses" :loading="loading" />
      <InCrowdDisplay title="Most Destructions" sub-title="Destroyed" :data="kills" :loading="loading" />
      <InCrowdDisplay title="Most Depressions" sub-title="Depressions" :data="deaths" :loading="loading" />
    </div>
  </div>
</template>

<script>
import InCrowdDisplay from '@/components/sorority-wars/incrowd/InCrowdDisplay.vue'

export default {
  name: 'SororityWarsFightWeeklyMM',
  components: { InCrowdDisplay },
  data () {
    return {
      bounties: [],
      events: [],
      energy: [],
      kills: [],
      wins: [],
      losses: [],
      deaths: [],
      week: '',
      loading: true,
      loadError: false
    }
  },
  mounted () {
    this.loadStandings()
  },
  methods: {
    loadStandings () {
      this.loading = true
      this.loadError = false

      return this.$axpi().$http().get('dynamics/sorority-wars/weekly-made-bitches')
        .then(response => {
          const data = response.data || {}
          const lists = data.lists || {}
          this.bounties = Array.isArray(lists.bounties) ? lists.bounties : []
          this.events = Array.isArray(lists.missions) ? lists.missions : []
          this.energy = Array.isArray(lists.energy_used) ? lists.energy_used : []
          this.kills = Array.isArray(lists.kills) ? lists.kills : []
          this.losses = Array.isArray(lists.fightslost) ? lists.fightslost : []
          this.wins = Array.isArray(lists.fightswon) ? lists.fightswon : []
          this.deaths = Array.isArray(lists.deaths) ? lists.deaths : []
          this.week = data.week || ''
        })
        .catch(() => {
          this.loadError = true
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style scoped>
.leaderboard-page__intro {
  display: flex;
  min-height: 58px;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.leaderboard-page__heading {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 8px;
}

.leaderboard-page__icon {
  display: flex;
  flex: 0 0 38px;
  width: 38px;
  height: 38px;
  align-items: center;
  justify-content: center;
  color: #ad1f51;
  background: rgba(255, 255, 255, 0.72);
  border: 1px solid rgba(232, 64, 99, 0.38);
  border-radius: 7px;
}

.leaderboard-page__icon svg {
  width: 22px;
  height: 22px;
  fill: none;
  stroke: currentColor;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 1.7;
}

.leaderboard-page__period {
  overflow: hidden;
  max-width: 230px;
  flex: 0 1 auto;
  padding: 4px 7px;
  color: #0b5aa8;
  background: #fff;
  border: 1px solid rgba(35, 140, 189, 0.42);
  border-radius: 9999px;
  font-size: 11px;
  font-weight: 800;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.leaderboard-page__grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 5px;
}

.leaderboard-page__error {
  display: flex;
  min-height: 130px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 3px;
  padding: 10px;
  color: #5b7183;
  background: #fff;
  border: 1px solid #e84063;
  border-radius: 7px;
  font-size: 14px;
  text-align: center;
}

.leaderboard-page__error strong {
  color: #ad1f51;
  font-size: 14px;
}

@media only screen and (min-width: 720px) and (max-width: 1069px) {
  .leaderboard-page__grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media only screen and (min-width: 1070px) {
  .leaderboard-page__grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

@media only screen and (max-width: 480px) {
  .leaderboard-page__period {
    max-width: 100px;
  }
}
</style>
